<template>
  <div class="about-us-content" id="a-globo-sobre-nos" data-search-anchor> 
  <div class="about-us-globo-content">
    <div>      
      <p class="about-us-globo-description">{{ aboutUsDescription }}</p>
    </div>    
  </div>
    <div class="about-us-img-bottom-content">
      <div class="about-us-img-bottom" :style="{ backgroundImage: `url(${aboutUsImageSrc})` }"></div>
    </div>
  </div>
</template>

<script lang="ts">
import { PageStoreContract } from '@/data/store/page.store.contract'
import GloboPageMixin from '@/mixins/globo-page-mixin'
import { GloboPageStore } from '@/store/globo-page/globo-store'
import { Component, Mixins } from 'vue-property-decorator'
import { getModule } from 'vuex-module-decorators'

@Component({})
export default class AboutUsGloboSection extends Mixins(GloboPageMixin) {
  globoPageStore: PageStoreContract = getModule(GloboPageStore, this.$store)

  get aboutUsDescription(): string {
    return this.getElementText(2, 1)
  }
  get aboutUsImageSrc(): string {
    return this.getElementMedia(2, 2)
  }

  async getGloboPage(): Promise<void> {
    await this.globoPageStore.getDataPage()
  }

  async mounted(): Promise<void> {
    if (!this.globoPageStore.isLoading) {
      await this.getGloboPage()
    }
  }
}
</script>

<style lang="scss">
.about-us-content{
  max-width: 1032px;
  width: 100%;
}
.about-us-globo-content {
  display: grid;    
  max-width: 1032px;  
  padding-top: 0rem;
}

.about-us-globo-description {  
  font-size: 38px;
  font-weight: 400;
  line-height: 43px;
  text-align: left;
  margin: 0;  
}

.about-us-img {
  position: relative;
  width: 98%;
  max-width: 551px;
  height: 578px;

  background-repeat: no-repeat;
  background-position: center;
  background-size:contain;
  margin-bottom: 2rem;
}
.about-us-img-bottom-content {
  max-width: 1032px;
  padding-bottom: 2rem;
  .about-us-img-bottom {
    position: relative;
    width: 1032px;   
    height: 348px;
    border-radius: 6px;
  
    background-repeat: no-repeat;    
    background-size: cover;
    margin-top: 2rem;
  }
}
</style>
